
import { 
  ExternalLink, 
  FileText, 
  PhoneCall,
  Mail,
  Trash2 
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { toast } from 'sonner';

interface LeadRowActionsProps {
  lead: any;
  isDeleting: string | null;
  onDelete: (id: string) => Promise<void>;
}

export function LeadRowActions({ lead, isDeleting, onDelete }: LeadRowActionsProps) {
  const handleEmailClick = () => {
    if (lead.email) {
      window.location.href = `mailto:${lead.email}`;
    } else {
      toast.error("No email address available");
    }
  };

  const handlePhoneClick = () => {
    if (lead.phone) {
      window.location.href = `tel:${lead.phone}`;
    } else {
      toast.error("No phone number available");
    }
  };

  return (
    <div className="flex space-x-1">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button 
              size="sm" 
              variant="ghost" 
              className="h-8 w-8 p-0"
              onClick={() => window.open(`/nursing-homes/${lead.location?.toLowerCase()}/${lead.nursing_home_id}`, '_blank')}
            >
              <ExternalLink className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>View nursing home details</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              size="sm"
              variant="ghost"
              className="h-8 w-8 p-0"
              onClick={handlePhoneClick}
            >
              <PhoneCall className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Call nursing home</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              size="sm"
              variant="ghost"
              className="h-8 w-8 p-0"
              onClick={handleEmailClick}
            >
              <Mail className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Email nursing home</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <Button 
              size="sm" 
              variant="ghost" 
              className="h-8 w-8 p-0"
              onClick={() => window.open(`/dashboard/leads/${lead.id}`, '_blank')}
            >
              <FileText className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>View notes and history</TooltipContent>
        </Tooltip>
        
        <Tooltip>
          <TooltipTrigger asChild>
            <Button 
              size="sm" 
              variant="ghost" 
              className="h-8 w-8 p-0 text-red-500 hover:text-red-700 hover:bg-red-50"
              onClick={() => onDelete(lead.id)}
              disabled={isDeleting === lead.id}
            >
              {isDeleting === lead.id ? (
                <span className="h-4 w-4 animate-spin rounded-full border-2 border-red-500 border-t-transparent" />
              ) : (
                <Trash2 className="h-4 w-4" />
              )}
            </Button>
          </TooltipTrigger>
          <TooltipContent>Remove from list</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
